const principles = [
  {
    icon: 'ri-check-double-line',
    title: '先核实再收录',
    desc: '每一条资源都经过人工试用与核对，排除失效与劣质入口，保证真正能用。',
  },
  {
    icon: 'ri-tools-line',
    title: '按需分类整理',
    desc: '不用关键词堆砌，而是按真实使用场景分类，让你一进来就能找到对的位置。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每周滚动更新',
    desc: '热门工具与资料合集持续增补，失效资源及时下架，清单保持鲜活。',
  },
  {
    icon: 'ri-heart-line',
    title: '免费开放使用',
    desc: '收录以免费或可商用资源为主，导航本身不设门槛，收藏夹也不限数量。',
  },
];

const praises = [
  {
    role: '设计师 · 小林',
    text: '找免版权素材和配色灵感以前要开一堆网页，现在 51全网 一个目录就够，收藏夹攒了不少好东西。',
  },
  {
    role: '自由职业者 · 阿卓',
    text: '模板和格式转换工具集中在一起很省心，做简历、传文件都快了不少，基本每两周回来逛一次。',
  },
];

const Faq = () => {
  const faqs = [
    {
      q: '51全网收录哪些类型的资源？',
      a: '目前主要收录常用效率工具、设计灵感、免版权素材、开发辅助、AI 工具、模板文档、学习资料与实用小工具网站八大类，后续会根据热门需求持续扩充分类。',
    },
    {
      q: '这里的资源都是免费的吗？',
      a: '绝大多数以免费或提供免费档位的资源为主，个别需付费订阅或商用的会在标注中提示。使用前建议留意各资源的授权说明。',
    },
    {
      q: '收藏夹有什么用？会不会丢失？',
      a: '点击资源卡片右上角的收藏按钮即可保存到页顶的收藏夹。收藏数据保存在当前浏览器中，方便你下次访问快速定位，建议对重要资源保留自己的本地备份。',
    },
    {
      q: '如何通过搜索快速找资源？',
      a: '在首屏或结果区顶部的搜索框输入关键词即可实时筛选，也可点击“大家都在找”的标签快速定位对应分类，找到后直接收藏即可。',
    },
    {
      q: '我发现一个好用的网站，可以推荐收录吗？',
      a: '非常欢迎。你可以通过页脚的邮箱联系我们，附上网站名称、链接和一句话介绍，审核通过后就会按分类收录并随更新发布。',
    },
  ];

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  return (
    <section id="faq" aria-label="常见问题">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-semibold uppercase tracking-widest text-accent-700">FAQ</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            常见问题
          </h2>
          <p className="mt-3 text-sm leading-6 text-foreground-700">
            关于收录范围、免费授权与收藏使用的说明，一次讲清楚。
          </p>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((f) => (
            <details
              key={f.q}
              className="group rounded-lg border border-background-200 bg-background-50 px-5 py-4 open:border-primary-200 open:bg-background-50"
            >
              <summary className="flex cursor-pointer list-none items-center gap-3 text-sm font-semibold text-foreground-950 md:text-base">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-question-line text-sm" aria-hidden="true" />
                </span>
                <span className="flex-1">{f.q}</span>
                <i className="ri-add-line text-xl text-foreground-500 transition-transform group-open:rotate-45" aria-hidden="true" />
              </summary>
              <p className="mt-3 border-t border-background-200 pt-3 pl-9 text-sm leading-6 text-foreground-700">
                {f.a}
              </p>
            </details>
          ))}
        </div>
      </div>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </section>
  );
};

export default Faq;